import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings from 'react-localization';

interface IUserStrings extends LocalizedStringsMethods {
    lsHomeTxt: string;
    lsUsersTxt: string;
    lsUsrNameTxt: string;
    lsUsrAlreadyExistTxt: string;
    lsFNameTxt: string;
    lsLNameTxt: string;
    lsEmailTxt: string;
    lsMobilePhTxt: string;
    lsRoleTxt: string;
    lsOrgTxt: string;
    lsCancelTxt: string;
    lsUsrAddSuccessTxt: string;
    lsUsrUpdateSuccessTxt: string;
    lsAddTxt: string;
    lsEditTxt: string;
    lsAddUsrTxt: string;
    lsEditUsrTxt: string;
    lsSaveTxt: string;
    lsNextTxt: string;
    lsPrevTxt: string;
    lsDeleteTestTxt: string;
    lsAddProfileTxt: string;
    lsAllowedTxt: string;
    lsNotAllowedTxt: string;
}

let strings: IUserStrings;
export default strings = new LocalizedStrings({
    en: {
        lsHomeTxt: 'Home',
        lsUsersTxt: 'Users',
        lsUsrNameTxt: 'Username',
        lsUsrAlreadyExistTxt: 'Username already exists!',
        lsFNameTxt: 'First Name',
        lsLNameTxt: 'Last Name',
        lsEmailTxt: 'Email',
        lsMobilePhTxt: 'Mobile Phone',
        lsRoleTxt: 'Role',
        lsOrgTxt: 'Organization',
        lsCancelTxt: 'Cancel',
        lsUsrAddSuccessTxt: 'User added successfully!',
        lsUsrUpdateSuccessTxt: 'User updated successfully!',
        lsAddTxt: 'Add',
        lsEditTxt: 'Edit',
        lsAddUsrTxt: 'Add User',
        lsEditUsrTxt: 'Edit User',
        lsSaveTxt: 'Save',
        lsNextTxt: 'Next',
        lsPrevTxt: 'Previous',
        lsDeleteTestTxt: 'Test Deletion',
        lsAddProfileTxt: 'Add Profiles',
        lsAllowedTxt: 'Allowed',
        lsNotAllowedTxt: 'Not Allowed',
    },
    es: {
        lsHomeTxt: 'Casa',
        lsUsersTxt: 'Usuarios',
        lsUsrNameTxt: 'Nombre de usuario',
        lsUsrAlreadyExistTxt: 'nombre de usuario ya existe!',
        lsFNameTxt: 'Nombre de pila',
        lsLNameTxt: 'Apellido',
        lsEmailTxt: 'Email',
        lsMobilePhTxt: 'Teléfono móvil',
        lsRoleTxt: 'Role',
        lsOrgTxt: 'Organización',
        lsCancelTxt: 'Cancelar',
        lsUsrAddSuccessTxt: 'Usuario agregado con éxito!',
        lsUsrUpdateSuccessTxt: 'Usuario actualizado con éxito!',
        lsAddTxt: 'Añadir',
        lsEditTxt: 'Editar',
        lsAddUsrTxt: 'Agregar usuario',
        lsEditUsrTxt: 'editar usuario',
        lsSaveTxt: 'Salvar',
        lsNextTxt: 'Next',
        lsPrevTxt: 'Previous',
        lsDeleteTestTxt: 'Prueba de eliminación',
        lsAddProfileTxt: 'Add Profiles',
        lsAllowedTxt: 'Permitido',
        lsNotAllowedTxt: 'No permitido',
    },
});



// WEBPACK FOOTER //
// ./src/eyeguide-localization/user/string.user.addedit.tsx